<template>
    <v-layout align-center justify-start mb-3>
        <!--{{bookExchange}} && {{checkBookGroups}} && {{noBookExchange}}-->

        <div v-if="!noBookExchange" class="ml-5">
            <v-chip class="px-2 py-2">
                <v-icon class="mr-2">info</v-icon>
                <i>
                    Μπορείτε να παραλάβετε το σύγγραμμα από άλλον φοιτητή.<br>
                    Με την παραλαβή του, θα κερδίσετε <u class="red--text">{{util.getCredit(book,statementBookGroupType,true)}} μονάδες </u>.
                    (Διαθέσιμο από: {{this.available}} φοιτητή/ες)
                    <br/>
                </i>
            </v-chip>
        </div>

            <div v-if="bookExchange" class="ml-4">

                <v-tooltip right v-if="this.available > 0 && checkBookGroups">
                    <v-btn @click="openAlertCourier" color="info" round slot="activator" small
                           v-if="bookExchange">
                        <v-icon>check</v-icon>
                        Παραλαβή από Φοιτητή
                    </v-btn>
                    <span>Παραλαβή μέσω ανταλλαγής</span>
                </v-tooltip>
            </div>

        <small v-if="this.available > 0 &&  !checkBookGroups && !noBookExchange">
            <u><i>Πατηστε τελικη υποβολή για ενεργοποίηση</i></u>
        </small>

            <div v-if="noBookExchange" class="ml-5">
                <v-chip>
                    <v-icon class="mr-2">info</v-icon>
                    <i>Επιλέξατε να παραλάβετε το σύγγραμμα από άλλον φοιτητή.</i>
                </v-chip>


                <v-tooltip right>
                    <v-btn @click="openInformationDialog" color="info" round slot="activator" small>
                        Στοιχεία ανταλλαγής
                    </v-btn>
                    <span>Παραλαβή μέσω ανταλλαγής</span>
                </v-tooltip>
            </div>
    </v-layout>
</template>

<script>

    import requests from "../../requests";
    import util from "../../utilities";

    export default {
        name: "CourierTypeComponent",
        props: {
            book: Object,
            statementBookGroupType: String
        },
        data() {
            return {
                util,
                availableExchanges: 0
            }

        },
        methods: {
            openAlertCourier() {
                if (confirm("Το σύστημα θα επιλέξει ένα απο τα διαθέσιμα βιβλία για ανταλλαγή. " +
                    "Σε περίπτωση που επιλεγεί η παραλαβή από φοιτητή η διαδικασία δεν μπορεί " +
                    "να ακυρωθεί πριν το πέρας των 5 ημερών. Είστε σίγουρος/η ότι θέλετε να συνεχίσετε;")) {
                    this.checkExchangeFlag();
                }
            },
            callBuckSuccessExchangeStudentData(response){
                this.$store.commit('setBookExchange', response);
                var exchangeStudentData;
                this.$store.commit('setInformationDialog', true);
                exchangeStudentData = {student: response.student,
                    exchangeDestinationId: response.exchangeDestinationId, statementBookId: response.statementBookId , exchangeDestinationDateSelected: response.exchangeDestinationDateSelected};
                this.$store.commit('setExchangeStudentData', exchangeStudentData);
                this.$store.commit('setLoadingModal', false);
            },
            openInformationDialog() {
                this.$store.commit('setLoadingModal', true);
                var bookSelect = this.$store.getters.bookSelect;
                if (Object.keys(bookSelect) == 0) {
                    requests.exchangeStudentData(this.book.exchangeSourceId, this.callBuckSuccessExchangeStudentData)
                }
                else {
                    this.$store.commit('setBookExchange', bookSelect[this.book.id]);
                    requests.exchangeStudentData(bookSelect[this.book.id].exchangeSourceId, this.callBuckSuccessExchangeStudentData)
                }
            },
            checkId() {
                var match = this.$store.getters.match;
                var count = 0;
                var temp;
                for (var i = 0; i < match.length; i++) {
                    if (match[i].dstStatementBookId === this.book.id) {
                        count++;
                        temp = i;
                    }
                }
                if (count > 0) {
                    this.availableExchanges = match[temp].available;
                }
            },
            //setBookExchangeFlag
            checkExchangeFlag() {
                var bookSelect = this.$store.getters.bookSelect;
                var dstStatementBookId =  {};
                if (Object.keys(bookSelect) == 0) {
                    dstStatementBookId = {dstStatementBookId: this.book.statementBookId}
                }
                else {
                    dstStatementBookId = {dstStatementBookId: bookSelect[this.book.id].statementBookId};
                }
                const bookExchangeFlag = this.$store.getters.bookExchangeFlag;
                var exchangeType = this.$store.getters.exchangeType;

                for (let bookId in exchangeType) {
                    if (bookId == this.book.id) {
                        exchangeType[bookId].bookExchangeFlag = false;
                        bookExchangeFlag[bookId] = ({bookExchangeFlag: false});
                        break;
                    }
                }
                this.$store.commit('setBookExchangeFlag', bookExchangeFlag);
                this.$store.commit('setExchangeType', exchangeType);
                this.$store.commit('setLoadingModal', true);
                requests.select(dstStatementBookId, this.callBuckSuccessdstStatementBookId);
            },
            callBuckSuccessdstStatementBookId(response){
                this.book = response;
                var active = this.$store.getters.active;

                for (var i = 0; i < active.bookGroups.length; i++) {
                    if (active.bookGroups[i].books[0].book.id == response.id) {
                        active.bookGroups[i].books[0].book = response;
                    }
                }
                this.createBookSelect(active);
                this.$store.commit('setActive', active);
                this.$store.commit('setLoadingModal', false);
            },
            createBookSelect(active) {
                var statementBookId;
                var exchangeSourceId;
                var bookSelect = {};
                for (var i = 0; i < active.bookGroups.length; i++) {
                    statementBookId = active.bookGroups[i].books[0].book.statementBookId;
                    if (active.bookGroups[i].books[0].book.hasOwnProperty('exchangeSourceId')) {
                        exchangeSourceId = active.bookGroups[i].books[0].book.exchangeSourceId;
                        bookSelect[active.bookGroups[i].books[0].id.bookId] = {statementBookId: statementBookId, exchangeSourceId: exchangeSourceId};
                    }
                    else {
                        bookSelect[active.bookGroups[i].books[0].id.bookId] = {statementBookId: statementBookId};
                    }
                }
                this.$store.commit('setBookSelect', bookSelect);
            }
        },
        computed: {
            available: function () {
                return this.availableExchanges;
            },
            checkBookGroups: function () {
                var bookGroups = this.$store.getters.active.bookGroups;
                for (var i = 0; i < bookGroups.length; i++) {
                    if (bookGroups[i].books.length > 0) {
                        if (bookGroups[i].books[0].book.id == this.book.id) {
                            return true
                        }
                    }
                }
                return false
            },
            noBookExchange: function () {
                var bookGroups = this.$store.getters.active.bookGroups;

                if (bookGroups != undefined)
                    for (var i = 0; i < bookGroups.length; i++) {
                        if (bookGroups[i].books.length > 0) {
                            if (bookGroups[i].books[0].book.id == this.book.id) {
                                if (bookGroups[i].books[0].book.hasOwnProperty('exchangeSourceId')  && !bookGroups[i].books[0].book.delivered) {
                                    return true
                                }
                            }
                        }
                    }
                return false
            },
            bookExchange: function () {
                var exchangableStatementBooks = false;
                var match = this.$store.getters.match;

                for (var i = 0; i < match.length; i++){
                    if (match[i].dstStatementBookId == this.book.id){
                        exchangableStatementBooks = true;
                        break;
                    }
                }

                var bookGroups = this.$store.getters.active.bookGroups;
                // if (bookGroups.length == 0)
                //     return false;
                for (var i = 0; i < bookGroups.length; i++) {
                    if (bookGroups[i].books.length > 0) {
                        if (bookGroups[i].books[0].book.id == this.book.id) {
                            if (bookGroups[0].books[0]) {
                                if (!bookGroups[i].books[0].book.hasOwnProperty('exchangeSourceId') && exchangableStatementBooks &&
                                    !bookGroups[0].books[0].book.expired && !bookGroups[i].books[0].book.delivered) {
                                    return true
                                }
                            }
                        }
                    }
                }
                return false
            },
            buttonTextField: function() {
                return !this.$store.getters.pinFlag? "Πατηστε τελικη υποβολή για ενεργοποίηση" : "Παραλαβή από Φοιτητή"
            }
        },
        created() {
            this.checkId();
            util.getCredit(this.book,this.statementBookGroupType);
        }
    }
</script>

<style scoped>

</style>
